module.exports = __webpack_public_path__ + "static/media/ios-step2.536f70e7.png";